export default "__VITE_ASSET__BMxqO2Wd__"